import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import styled from 'styled-components';
import useWindowDimensions from './Dimention';

const SegmentedStyle = styled.div`
  ${({ screenw, isLargeTab, theme }) =>
    screenw > 949 || isLargeTab
      ? `
    .MuiTabs-root {
      background-color: ${theme.tabBg1};
      border-radius: 4px;
      width: 100%;
      max-width: ${screenw && screenw <= 600 ? `${screenw - 20}px` : '100%'};
      overflow-x: auto;
    }

    .MuiTabs-flexContainer {
      flex-wrap: nowrap;
      min-width: max-content;
    }

    .MuiTab-root {
      font-weight: 600;
      text-transform: none;
      font-size: 15px;
      min-width: 100px;
      color: ${theme.tabText1};
    }

    .Mui-selected {
      color: ${theme.text1} !important;
    }
  `
      : `
    .MuiTabs-root {
      min-height: inherit;
      max-width: ${screenw && screenw <= 600 ? `${screenw - 30}px` : '100%'};
      background-color: ${theme.Bg1};
    }
    .MuiTab-root {
      font-weight: 600;
      text-transform: none;
      font-size: 14px;
      color: ${theme.fieldText1};
      padding: 8px 12px !important;
      border-radius: 20px;
      border: 1px solid ${theme.border1};
      margin: 0 2px;
      min-height: inherit;
      line-height: inherit;
      letter-spacing: inherit;
      min-width: 70px;
    }

    .Mui-selected {
      color: #E7E8EA !important;
      background-color: #08979c;
    }

    .MuiTabs-indicator {
      display: none;
    }
    .MuiTabScrollButton-root {
      display: none;
    }
  `};
`;

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({
  tabList,
  handleTabChange,
  callbackTabIndex,
  defaultTabValue,
  isLargeTab
}) {
  const { screenW } = useWindowDimensions();
  const [value, setValue] = React.useState(0);
  React.useEffect(() => {
    setValue(defaultTabValue || 0);
  }, [defaultTabValue]);

  const handleChange = (_, newValue) => {
    setValue(newValue);
    handleTabChange && handleTabChange(newValue);
  };

  React.useEffect(() => {
    if (callbackTabIndex) {
      setValue(callbackTabIndex);
    }
  }, [callbackTabIndex]);

  return (
    <SegmentedStyle
      className="segmented-tab"
      screenw={screenW || screen.availWidth}
      isLargeTab={isLargeTab}
    >
      <Box sx={{ width: '100%' }}>
        <Tabs
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="scrollable force tabs tabs"
          value={value}
          onChange={handleChange}
        >
          {tabList.map((list, index) => {
            return <Tab key={index} label={list.label} {...a11yProps(index)} />;
          })}
        </Tabs>
      </Box>
      {tabList.map((dd, index) => {
        return (
          <CustomTabPanel key={index} value={value} index={index}>
            {dd.content}
          </CustomTabPanel>
        );
      })}
    </SegmentedStyle>
  );
}
